const generalDocuments = [
    {
        'name': 'IC (All Directors)',
        'requestName': 'Ic',
        'description': '*Copies cross with "For Merchant Application Only"',
        'isChecked': false,
        'required': true,
        'files': []
    },
    {
        'name': 'Company Full Bank Statement (3 Months)',
        'requestName': 'CompanyBankStatements',
        'description': null,
        'isChecked': false,
        'required': true,
        'files': []
    },
    {
        'name': 'Shop Photos (1 Signboard, 3 interior)',
        'requestName': 'ShopPhotos',
        'description': '*Rename photo to outlet name',
        'isChecked': false,
        'required': true,
        'files': []
    },
    {
        'name': 'Company Write Up',
        'requestName': 'CompanyWriteUp',
        'description': '*Optional – give nature of business in mandarin for Alipay',
        'isChecked': false,
        'required': false,
        'files': []
    },
    {
        'name': 'Application Form',
        'requestName': 'ApplicationForm',
        'description': null,
        'isChecked': false,
        'required': true,
        'files': []
    }
];

export const sdnBhdDocuments = [
    {
        'name': 'M & A',
        'requestName': 'MA',
        'description': null,
        'isChecked': false,
        'required': true,
        'files': []
    },
    {
        'name': 'Form 9',
        'requestName': 'Form9',
        'description': null,
        'isChecked': false,
        'required': true,
        'files': []
    },
    {
        'name': 'Form 24',
        'requestName': 'Form24',
        'description': null,
        'isChecked': false,
        'required': true,
        'files': []
    },
    {
        'name': 'Form 44',
        'requestName': 'Form44',
        'description': null,
        'isChecked': false,
        'required': false,
        'files': []
    },
    {
        'name': 'Form 49',
        'requestName': 'Form49',
        'description': null,
        'isChecked': false,
        'required': true,
        'files': []
    },
    ...generalDocuments
];

export const solePartnerLlpDocuments = [
    {
        'name': 'SSM / LLP (Full Set)',
        'requestName': 'SsmLlp',
        'description': null,
        'isChecked': false,
        'required': true,
        'files': []
    },
    ...generalDocuments
];

export const newCompaniesActDocuments = [
    {
        'name': 'Section 14',
        'requestName': 'Section14',
        'description': null,
        'isChecked': false,
        'required': true,
        'files': []
    },
    {
        'name': 'Section 15',
        'requestName': 'Section15',
        'description': null,
        'isChecked': false,
        'required': true,
        'files': []
    },
    {
        'name': 'Section 17',
        'requestName': 'Section17',
        'description': null,
        'isChecked': false,
        'required': true,
        'files': []
    },
    {
        'name': 'Section 58 & 236',
        'requestName': 'Section58And236',
        'description': null,
        'isChecked': false,
        'required': true,
        'files': []
    },
    ...generalDocuments
];
